// fn_profile_picker

var fn_profile_picker = function () {

    $(".modal-profile__wrapper").on("click", ".custom-control-input", function (e) {
        // 0
        var $radios = $('.modal-profile__wrapper input[type="radio"]');
        var currentCheckbox = $(this);
        // 1 Toggling active state of parent
        if (currentCheckbox.prop("checked")) {
            $radios.parent('.custom-control').removeClass('active')
            $(currentCheckbox).parent('.custom-control').addClass('active')
        }
        else {}
    //
    });

}